import { Icon } from "../Common.jsx";

/** Read-only or interactive star control. labels: {1:"…",…} from /meta. */
export default function StarRating({ value = 0, max = 5, labels = {}, onChange, size = 18 }) {
  const interactive = typeof onChange === "function";
  const stars = Array.from({ length: max }, (_, i) => i + 1);
  const ariaLabel = interactive
    ? "Rating"
    : `Rating: ${value} of ${max}${labels[value] ? ` — ${labels[value]}` : ""}`;

  return (
    <div
      role={interactive ? "radiogroup" : "img"}
      aria-label={ariaLabel}
      style={{ display: "inline-flex", gap: 2, alignItems: "center" }}
    >
      {stars.map((n) => {
        const filled = n <= value;
        const star = (
          <Icon
            name="star"
            size={size}
            style={{
              color: filled ? "var(--warning)" : "var(--border)",
              fill: filled ? "var(--warning)" : "none",
            }}
          />
        );
        if (!interactive) {
          return (
            <span key={n} style={{ lineHeight: 0 }}>
              {star}
            </span>
          );
        }
        return (
          <button
            key={n}
            type="button"
            role="radio"
            aria-checked={value === n}
            aria-label={`${n} — ${labels[n] || n}`}
            className="icon-btn"
            style={{ width: size + 12, height: size + 12 }}
            onClick={() => onChange(n)}
            onKeyDown={(e) => {
              if (e.key === "ArrowRight" || e.key === "ArrowUp") {
                e.preventDefault();
                onChange(Math.min(max, value + 1));
              }
              if (e.key === "ArrowLeft" || e.key === "ArrowDown") {
                e.preventDefault();
                onChange(Math.max(1, value - 1));
              }
            }}
          >
            {star}
          </button>
        );
      })}
    </div>
  );
}
